// extracted by mini-css-extract-plugin
module.exports = {"note":"CongratsNote_note__2pN63","title":"CongratsNote_title__YvDIH","text":"CongratsNote_text__2ZWdJ"};